import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const LoggedUser = () => {
  const user = useSelector(state => state.authentication.user);
  const history = useHistory();

  const navigateToSettings = () => {
    history.push('/settings');
  };

  return (
    <div>

      <div
        style={{
          position: "absolute",
          right: "8vw",
          top: 50,
          lineHeight: "20px",
          fontSize: "calc(0.5vw + 6px)",
          textAlign: "center",
          color: "black",
          fontFamily: "Quicksand-Medium",
        }}
      >
        <i
          className="fas fa-cog"
          style={{
            position: "relative",
            right: "0.5vw",
            fontSize: "calc(0.7vw + 8px)",
            color: "#555",
            cursor: "pointer",
          }}
          onClick={navigateToSettings}
          onMouseOver={(e) => {
            e.currentTarget.style.color = "#FBF433";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.color = "#555";
          }}
        />
        Użytkownik: <br /> {" "}
        <span
          style={{
            fontFamily: "Quicksand-Regular",
            fontWeight: "bold",
            textUnderlineOffset: "3px",
          }}
        >
          {user?.username}
        </span>
      </div>
    </div>
  );
};

export default LoggedUser;
